import { NodeToolbarBottom } from "../NodeToolbarBottom";
import { MenuWrapper } from "../MenuWrapper";
import { FloatingInterfacesTypeahead } from "../FloatingInterfacesTypeahead";
import { FloatingPagesTypeahead } from "../FloatingPagesTypeahead";

type Props = {
  interfaceProjectId: string | undefined;
  interfacePageId: string | undefined;
};

export function FloatingInterfacesAndPagesTypeaheads({
  interfaceProjectId,
  interfacePageId,
}: Props) {
  return (
    <NodeToolbarBottom>
      <MenuWrapper>
        <FloatingInterfacesTypeahead interfaceProjectId={interfaceProjectId} />
        {interfaceProjectId && (
          <FloatingPagesTypeahead
            interfaceProjectId={interfaceProjectId}
            interfacePageId={interfacePageId}
          />
        )}
      </MenuWrapper>
    </NodeToolbarBottom>
  );
}
